import { privateAxiosIntance } from "../../Config/axios";
import { protectedRoutes } from "../../Config/urls";

export const getGalleryFn = () => {
    try {
        const response = privateAxiosIntance.get(protectedRoutes.gallery);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getGalleryByIdFn = (id) => {
    try {
        console.log("ids", id)
        const response = privateAxiosIntance.get(`${protectedRoutes.gallery}`, {
            params: id
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteGalleryByIdFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.delete(`${protectedRoutes.gallery}`, { data: reqBody });
        return response;
    } catch (error) {
        throw error;
    }
}

export const postGalleryFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.post(protectedRoutes.gallery, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}

export const patchGalleryFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.patch(protectedRoutes.gallery, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}



